import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=ff767064&scoped=true&"
import script from "./submission.vue?vue&type=script&lang=js&"
export * from "./submission.vue?vue&type=script&lang=js&"
import style0 from "./submission.vue?vue&type=style&index=0&id=ff767064&prod&lang=scss&scoped=true&"
import style1 from "./submission.vue?vue&type=style&index=1&id=ff767064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff767064",
  null
  
)

export default component.exports